export const PLAYER_DISTANCE = 12; // for sensitivity of the angle of looking at the cursor
export const PLAYER_SCALE = 2.28 * PLAYER_DISTANCE; // consistent scale for the player
export const PLAYER_OFFSET = -0.3 * PLAYER_SCALE; // .25 for center, adjusted for closer to the bottom
export const PLAYER_OFFSET_X = 0; // keep the model centered in the player viewport
export const PLAYER_ARMS_ROTATION = Math.PI / 24;

export const HEAD_ANGLE_DISTANCE_OFFSET = 7;
export const HEAD_SCALE = 2.28 * PLAYER_DISTANCE; // follows the player scale
export const HEAD_OFFSET = -0.3 * HEAD_SCALE; // .25 for center
